<template>
  <div id="app">
    <header>
      <nav
        class="flex items-center justify-between flex-wrap p-6 container mx-auto 2xl:max-w-screen-xl"
      >
        <div class="flex items-center flex-shrink-0 mr-6">
          <svg
            class="fill-current h-8 -mr-1 -ml-5"
            width="40"
            height="40"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27 67.9371h31M59.002 67.1666l12.4868-33.1179"
              stroke="#2c3e50"
              stroke-width="15"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="font-semibold text-2xl tracking-tight font-mono"
            ><a href="/">Restimuli</a></span
          >
        </div>
        <div class="block lg:hidden">
          <button
            class="flex items-center px-3 py-2 border rounded border-gray-600 hover:text-black hover:border-black focus:outline-none"
            id="nav-toggle"
          >
            <svg
              class="fill-current h-3 w-3"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div
          class="w-full block flex-grow lg:flex lg:items-center lg:w-auto hidden"
          id="nav-content"
        >
          <div
            class="text-base lg:flex-grow lg:flex lg:justify-end lg:mr-4 font-medium"
          >
            <a
              href="/submit"
              class="block mt-4 lg:inline-block lg:mt-0 hover:text-black mr-8"
            >
              Want to see your company profile here?
            </a>
            <a
              href="/newsletter"
              class="block mt-4 lg:inline-block lg:mt-0 hover:text-black mr-8"
            >
              Newsletter
            </a>
            <a
              href="/manifesto"
              class="block mt-4 lg:inline-block lg:mt-0 hover:text-black mr-8"
            >
              Manifesto
            </a>
            <!-- <a
              href="/covid"
              class="block mt-4 lg:inline-block lg:mt-0 rounded py-0 px-1 hover:text-gray-800 bg-custom-pink text-white text-sm pt-xsmall fit-content mr-3"
            >
              COVID-19
            </a> -->
            <a
              href="https://publication.restimuli.com/" target="_blank"
              class="block mt-4 lg:inline-block lg:mt-0 rounded py-0.5 px-1.5 hover:text-gray-800 bg-custom-pink text-white text-sm fit-content mr-3"
              >Publication</a
            >
          </div>
          <div>
            <a
              href="/submit"
              class="inline-block text-base px-4 py-2 leading-none border-2 rounded text-white border-white hover:border-transparent hover:text-orange-700 hover:bg-white mt-4 lg:mt-0 font-black"
              >Create Profile</a
            >
          </div>
        </div>
      </nav>
    </header>
    <!--Hero-->
    <div
      class="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center mb-8 sm:mb-0 mt-16 2xl:max-w-screen-xl"
    ></div>

    <div class="relative -mt-12 lg:-mt-24">
      <svg
        viewBox="0 0 1428 174"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        class="w-full h-28 sm:h-32 md:h-40 lg:h-48 xl:h-64"
        preserveAspectRatio="none"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g
            transform="translate(-2.000000, 44.000000)"
            fill="#f8fafc"
            fill-rule="nonzero"
          >
            <path
              d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
              opacity="0.100000001"
            ></path>
            <path
              d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
              opacity="0.100000001"
            ></path>
            <path
              d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
              id="Path-4"
              opacity="0.200000003"
            ></path>
          </g>
          <g
            transform="translate(-4.000000, 76.000000)"
            fill="#F4F4F5"
            fill-rule="nonzero"
          >
            <path
              d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z"
            ></path>
          </g>
        </g>
      </svg>
    </div>

    <section class="bg-gray-100 pt-12 pb-20 -mt-0.5">
      <div class="container mx-auto px-2 pt-4 pb-6 text-gray-800 2xl:max-w-screen-xl">
        <h1
          class="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800"
        >
          How to create a profile for your company
        </h1>
        <div class="w-full mb-4">
          <div
            class="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"
          ></div>
        </div>
      </div>

      <div
        class="flex flex-wrap container mx-auto justify-center items-start text-left 2xl:max-w-screen-xl text-justify"
      >
        <div class="w-full md:w-1/3 p-4">
          <div class="lg:justify-center">
            <h2 class="text-xl font-bold leading-tight text-gray-800 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="1em"
                height="1em"
                style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 32 32"
                class="inline mr-1"
              >
                <path
                  d="M27.71 4.29a1 1 0 0 0-1.05-.23l-22 8a1 1 0 0 0 0 1.87l9.6 3.84l3.84 9.6a1 1 0 0 0 .9.63a1 1 0 0 0 .92-.66l8-22a1 1 0 0 0-.21-1.05zM19 24.2l-2.79-7L21 12.41L19.59 11l-4.83 4.83L7.8 13l17.53-6.33z"
                />
              </svg>
              Send a message
            </h2>
          </div>
          <div>
            <!-- If you'd like to find clients and investors who are aligned with your company's
            values and interested in your offering, the first step is to -->
            If you'd like to promote your company values to buyers and investors, the first step is to
            <a class="underline font-black" href="/contact">
              send us a message</a
            >.
            <p class="mt-3">
            We'll then get back to you to proceed with step two: profile creation/setup and subscription.
            </p>
          </div>
        </div>
        <div class="w-full md:w-1/3 p-4">
          <div class="lg:justify-center">
            <h2 class="text-xl font-bold leading-tight text-gray-800 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="1em"
                height="1em"
                style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 36 36"
                class="inline mr-1 "
              >
                <path
                  d="M31.43 16H10v2h21.43a1 1 0 0 0 0-2z"
                  class="clr-i-outline clr-i-outline-path-1"
                />
                <path
                  d="M31.43 24H10v2h21.43a1 1 0 0 0 0-2z"
                  class="clr-i-outline clr-i-outline-path-2"
                />
                <path
                  d="M15.45 10h16a1 1 0 0 0 0-2h-14z"
                  class="clr-i-outline clr-i-outline-path-3"
                />
                <path
                  d="M17.5 3.42a1.09 1.09 0 0 0-1.55 0l-8.06 8.06l-3.38-3.64a1.1 1.1 0 1 0-1.61 1.5l4.94 5.3L17.5 5a1.1 1.1 0 0 0 0-1.58z"
                  class="clr-i-outline clr-i-outline-path-4"
                />
              </svg>
              Message must include
            </h2>
          </div>
          <p>
            Your message must include:
            <ul class="list-inside list-disc ml-4 mt-2 text-left">
              <li>Your first and last name</li>
              <li>The name of your company</li>
              <li>Your role at your company</li>
              <li>Which of <a class="underline" target="_blank" href="https://docs.google.com/spreadsheets/d/1ZoKYUSz9Gf-bVFPZAW0FLUekecYJrfhlFI1BBbHiPTA/edit?usp=sharing">these value tags</a> best describe your company values (ranked in order of importance, limited to 8)</li>
            </ul>
          </p>
        </div>
        <div class="w-full md:w-1/3 p-4">
          <div class="lg:justify-center">
            <h2 class="text-xl font-bold leading-tight text-gray-800 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="1em"
                height="1em"
                style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
                class="inline mr-1"
              >
                <path
                  d="M10.933 13.519l-2.226-2.226l-1.414 1.414l3.774 3.774l5.702-6.84l-1.538-1.282z"
                />
                <path
                  d="M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                />
              </svg>
              Is your company eligible for a profile?
            </h2>
          </div>
          <p>
            Yes, as long as the following criteria are met:
            <ul class="list-inside list-disc ml-4 mt-2 text-left">
              <!-- <li>Your company offers essential industries resources (Transport/Logistics, Chemicals, PPE, Pharmaceuticals, Medical Devices, Diagnostics, Polymers, Sanitisers, etc.)</li> -->
              <li>Your company maintains a level of sustainability and ethical standards.</li>
              <!-- <li>Your supply chain maintains sustainability and ethical standards</li>
              <li>Your company has zero tolerance for modern slavery and human trafficking</li>
              <li>Your company does not use age, citizenship status, health, family history, gender, sexual orientation or ethnic background to access employment cultural fit</li> -->
            </ul>
          </p>
        </div>
        <div class="w-3/4 text-left text-justify">
          <h2 class="my-4 mt-16 text-3xl leading-tight font-bold">Why create a Restimuli profile</h2>
          <div class="w-full mb-4">
          <div
            class="h-1 gradient w-40 opacity-25 my-0 py-0 rounded-t"
          ></div>
        </div>
          <p class="my-4 mt-10 text-xl leading-tight ">
            <!-- Restimuli is the only supplier directory where companies offering essential and emergency resources (Pharma, PPE, Medical
                    Equipment, Diagnostics, Chemicals, Polymers, Logistics,
                    Sanitisers, etc.)
            describe their ethical /
                    environmental / social / governance / philanthropic values and where clients and investors come to discover, learn about and connect with the companies that align with them. -->
            <!-- Restimuli – the only business directory that allows buyers/investors to find suppliers based on their shared commitment to ethical / environmental / social / governance / philanthropic values – is the place for organizations selling (and/or donating) essential industries resources (Transport/Logistics, Chemicals, PPE, Pharmaceuticals, Medical Devices, Diagnostics, Polymers, Sanitisers, etc.) to tell potential buyers about their culture and standards and how their values translate into daily practices. -->
            Restimuli – the only business directory that allows buyers/investors to find suppliers based on their shared commitment to ethical, environmental, social, governance, and philanthropic values – is the place for organizations to tell potential buyers and investors about their culture and standards and how their values translate into daily practices.
            <!-- {/* table of features */} -->
                  <div class="bg-white my-8 rounded-2xl drop-shadow-lg">
                    <div class="mx-auto max-w-7xl pt-12 pb-8 sm:pb-0 px-4 sm:px-6 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:px-8">
                      <div>
                        <p class="text-lg font-semibold text-orange-700">
                          Everything you need
                        </p>
                        <h2 class="mt-2 text-3xl font-bold tracking-tight text-gray-900 text-left ">
                          A new channel to reach buyers and investors.
                        </h2>
                        <h3 class="mt-4 text-lg text-left">
                          Conveying credibility around societal commitments is
                          what Restimuli is about!
                        </h3>
                      </div>
                      <div class="mt-12 lg:col-span-2 lg:mt-0">
                        <dl class="space-y-6 sm:grid sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-4 sm:gap-x-6 sm:gap-y-4 sm:space-y-0 lg:gap-x-8">
                          <div class="relative">
                            <dt>
                              <!-- Heroicon name: outline/check -->
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                We build your profile and storefront
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base">
                              <h4>
                              Restimuli builds your catalogue and organizes all
                              your ESG/CSR and product content.
                              </h4>
                            </dd>
                          </div>

                          <div class="relative">
                            <dt>
                               <!-- Heroicon name: outline/check -->
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                Filter, browse & discover
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base ">
                              <h4>
                              Buyers and investors can easily find your products
                              in Restimuli. Buyers and investors can use filters
                              to help find suppliers (such as you) that share
                              their values.
                            </h4>
                            </dd>
                          </div>

                          <div class="relative">
                            <dt>
                              <!-- Heroicon name: outline/check -->
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                Learn
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base ">
                              <h4>
                              Buyers and investors can learn everything about
                              your ethical, environmental, social, governance, and philanthropic values and culture from your
                              profile and about your product credentials from
                              your storefront. 
                            </h4>
                              <!-- All while you are in control of
                              the narrative. -->
                            </dd>
                          </div>

                          <div class="relative">
                            <dt>
                              <!-- Heroicon name: outline/check -->
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                Attract more customer leads
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base ">
                              <h4>
                              Open the top of the funnel and convert leads to
                              customers, faster.
                              </h4>
                            </dd>
                          </div>

                          <div class="relative">
                            <dt>
                              <!-- Heroicon name: outline/check -->
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                Inform product donations
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base ">
                              <h4>
                              Present any product donation programmes in your
                              Restimuli profile.
                            </h4>
                            </dd>
                          </div>

                          <div class="relative">
                            <dt>
                              <!-- Heroicon name: outline/check -->
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                Modern 4th channel
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base ">
                              <h4>
                              Restimuli does not replace sales, distributors, or
                              your website - we complement them to help you
                              better market your products and company values
                              towards buyers and investors.
                              </h4>
                            </dd>
                          </div>

                          <div class="relative">
                            <dt>
                              <!-- Heroicon name: outline/check -->
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                One month or less to launch your
                                profile/storefront
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base ">
                              <h4>
                              Launch your profile and storefront in one month or
                              less!
                              </h4>
                            </dd>
                          </div>

                          <div class="relative">
                            <dt>
                              <!-- Heroicon name: outline/check --> 
                              <svg
                                class="absolute h-6 w-6 text-emerald-700"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 12.75l6 6 9-13.5"
                                />
                              </svg>
                              <h3 class="ml-9 text-lg font-medium leading-6 text-left">
                                Social proof
                              </h3>
                            </dt>
                            <dd class="mt-2 ml-9 text-base ">
                              <h4>
                              Benefit from the social proof of having your
                              company values presented by an independent party
                              on an independent site.
                              </h4>
                            </dd>
                          </div>
                        </dl>
                      </div>
                    </div>
                  </div>
                  <!-- {/* end of table of features */} -->
            <p class="mt-4">
            Many buyers continue to intensify their efforts to improve their management approaches and communications in relation to environmental, social and governance (ESG) issues, as investors and other key stakeholders increasingly consider a company’s environmental, social and governance performance alongside traditional financial metrics.
            </p>        
            <p class="mt-4">
              Many of these buyers are in the midst of rethinking their supply chain and diversifying their supplier base. As a result, buyers are being pitched all the time, but with no clarity about who they'd actually be doing business with, what the supplier's ethical standards are, or whether the supplier's offering aligns with their needs.
            </p>

            <p class="mt-4">
              Creating a company profile and digital storefront in Restimuli's business directory helps your company articulate its values and how well these are aligned with your operations. 
            </p> 
              <p class="mt-4">
              When it comes to the capital markets, investing within an ESG framework is now the fastest growing segment of the asset management industry. That said, ESG can sadly be used as a very loosely defined term for “greenwashing”.
              </p>            
              <p class="mt-4">
              This means transparency is key to ensuring that insights and analytics can be interpreted appropriately. Some could argue that climate is the single greatest issue for society, and this should receive the greatest consideration when assessing a company. Others may consider diversity and inclusion or a living wage policy to be of equal importance to any net zero target. Independently, there must be transparency to mitigate market confusion and enhance understanding among market participants.
              </p>
            <p class="mt-4">
              Having a profile will make initial conversations with buyers and investors more meaningful, informative and efficient because they'll have already identified as being in alignment with your company. 
              <!-- There are great clients wondering if a company like yours even exists right now. -->
            </p>
              

          
              <p class="mt-4">
              Restimuli is for the buyers that want clarity about who they'd actually be doing business with and what the supplier's ethical standards are. Restimuli reorders the steps of the procurement process. Because ideally, buyers should know what type of suppliers are aligned with their values before all the phone calls, emails, and meetings.
            </p>
          </p>

        </div>
      </div>


    <!-- Adding the FAQ -->

  <div
    :class="containerClass"
    aria-labelledby="faq-title"
    class="overflow-hidden py-20 sm:py-32 container mx-auto 2xl:max-w-screen-xl"
  >
    <div
      class="mx-auto max-w-2xl lg:mx-0"
    >
      <h2
        id="faq-title"
        class="font-display text-3xl tracking-tight text-slate-900 sm:text-4xl font-semibold px-4"
      >
        Is Restimuli right for you?
      </h2>
      <!-- <p class="mt-4 text-lg tracking-tight text-slate-700">
        If you can’t find what you’re looking for, email our support team
        and if you’re lucky someone will get back to you.
      </p> -->
    </div>
    <ul
      role="list"
      class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3 whitespace-pre-wrap px-4 text-justify"
    >
      <li v-for="(column, columnIndex) in faqs" :key="columnIndex">
        <ul role="list" class="flex flex-col gap-y-8">
          <li v-for="(faq, faqIndex) in column" :key="faqIndex">
            <h3 class="font-display text-lg leading-7 text-slate-900 font-semibold">
              {{ faq.question }}
            </h3>
                                 <h4 class="mt-4 text-base text-slate-700" v-html="generateAnswer(faq)"></h4>

          </li>
        </ul>
      </li>
    </ul>
    </div>
  </section>




    <!-- End of FAQ -->

    <!-- Change the colour #F4F4F5 to match the previous section colour -->
    <svg
      class="wave-top"
      viewBox="0 0 1439 147"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1.000000, -14.000000)" fill-rule="nonzero">
          <g class="wave" fill="#F4F4F5">
            <path
              d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z"
            ></path>
          </g>
          <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
            <g
              transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) "
            >
              <path
                d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                opacity="0.100000001"
              ></path>
              <path
                d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                opacity="0.100000001"
              ></path>
              <path
                d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                opacity="0.200000003"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>

    <section class="container mx-auto text-center pt-6 mb-8">
      <!-- <h1
        class="w-full my-2 text-5xl font-bold leading-tight text-center text-white"
      >
        This list is continuously updated
      </h1> -->
      <!-- <div class="w-full mb-4">
        <div
          class="h-1 mx-auto bg-white w-1/6 opacity-25 my-0 py-0 rounded-t"
        ></div>
      </div> -->

      <h2 class="my-4 mt-8 text-3xl leading-tight">
Market your products and company values online
      </h2>

      <p class="mt-12 mb-8">
        <a
          class="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-lg py-4 px-8 shadow-lg"
          href="/submit"
          target="_blank"
        >
          Create a profile
        </a>
      </p>

      <div class="w-full mb-4 mt-20">
        <div
          class="h-1 mx-auto bg-white w-4/6 opacity-25 my-0 py-0 rounded-t"
        ></div>
      </div>


      <form class="w-full max-w-md mx-auto mt-16" action="https://restimuli.us5.list-manage.com/subscribe/post" method="POST" target="_blank">
        <input type="hidden" name="u" value="f82c7f82dbca46f5f83765b6a">
        <input type="hidden" name="id" value="36cf36b57d">
        <div class="flex md:flex-nowrap flex-wrap items-center py-2">          
          <input
            class="appearance-none bg-white w-11/12 lg:w-full lg:mr-3 py-2 px-2 focus:outline-none focus:bg-gray-100 focus:border-orange-900 text-sm placeholder-orange-600 newsletter_placeholder border-2 border-white rounded mx-auto"
            type="email"
            :placeholder="' ' + icon + '   Enter your email...'"
            aria-label="email" autocapitalize="off" autocorrect="off" name="MERGE0" id="MERGE0" size="25" value="">
          <button
            class="flex-shrink-0 bg-custom-pink hover:bg-orange-900 border-custom-pink hover:border-orange-900 text-sm border-2 text-white py-2 px-2 rounded font-medium mx-auto mt-4 md:mt-0 focus:outline-none"
            type="submit"
          >
            Get new profiles
          </button>
        </div>
      </form>

      <div class="text-xs text-orange-300 mt-5">
        <span>
          Join Restimuli's newsletter. By joining, you agree to the
          <a href="/legal" class="">Terms of Service</a>
        </span>
      </div>

     <!-- Footer code -->

     <div class="mt-20 text-left">
        <div
          class="max-w-6xl m-auto text-gray-800 flex flex-wrap justify-center"
        >
          <div class="p-5 w-40">
            <div class="text-xs uppercase text-white font-medium">Product</div>
            <a class="my-3 block" href="/submit"
              >Want to see your company profile at Restimuli?<span
                class="text-white text-xs p-1"
              ></span></a
            >
            <!-- <a class="my-3 block" href="/covid"
              >COVID-19 <span class="text-white text-xs p-1">New</span></a
            > -->
          </div>
          <div class="p-5 w-42">
            <div class="text-xs uppercase text-white font-medium">
              Create a profile
            </div>
            <a class="my-3 block" href="/contact"
              >Contact sales <span class="text-white text-xs p-1"></span></a
            >
            <a class="my-3 block" target=”_blank” href="https://publication.restimuli.com/memo/"
              >Suppliers memo  <span class="text-white text-xs p-1">New</span></a
            >
            <!-- <a class="my-3 block" href="/consulting"
              >Book a first 1:1 consultation<span class="text-white text-xs p-1"
                >New</span
              ></a
            > -->
          </div>
          <div class="p-5 w-40">
            <div class="text-xs uppercase text-white font-medium">
              Info
            </div>
            <a class="my-3 block" href="/legal"
              >Privacy & terms <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/contact" target="_blank"
              >Contact us <span class="text-white text-xs p-1"></span
            ></a>
          </div>
          <div class="p-5 w-48 sm:w-40 ">
            <div class="text-xs uppercase text-white font-medium">On us</div>
            <!-- <a class="my-3 block" href="https://twitter.com/restimuli" target="_blank"
              >About us <span class="text-white text-xs p-1"></span>
              </a> -->
            <a class="my-3 block" href="https://publication.restimuli.com/" target="_blank">
              Publication
              <span class="text-white text-xs p-1">New</span>
            </a>  
            <a class="my-3 block" href="/manifesto"
              >Manifesto
            </a>
              <a class="my-3 block" href="/newsletter"
              >Newsletter <span class="text-white text-xs p-1">New</span></a
            >
          </div>
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">Home</div>
            <a class="my-3 block" href="/#"
              >Services <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Products <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >About Us <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Pricing <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Partners <span class="text-white text-xs p-1">New</span></a
            >
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">User</div>
            <a class="my-3 block" href="/#"
              >Sign in <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >New Account <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Demo <span class="text-white text-xs p-1">New</span></a
            ><a class="my-3 block" href="/#"
              >Career
              <span class="text-white text-xs p-1">We're hiring</span></a
            ><a class="my-3 block" href="/#"
              >Surveys <span class="text-white text-xs p-1">New</span></a
            >
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Resources
            </div>
            <a class="my-3 block" href="/#"
              >Documentation <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Tutorials <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Support <span class="text-white text-xs p-1">New</span></a
            >
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Product
            </div>
            <a class="my-3 block" href="/#"
              >Our Products <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Great Deals <span class="text-white text-xs p-1">New</span></a
            ><a class="my-3 block" href="/#"
              >Analytics <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Mobile <span class="text-white text-xs p-1"></span
            ></a>
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Support
            </div>
            <a class="my-3 block" href="/#"
              >Help Center <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Privacy Policy <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Conditions <span class="text-white text-xs p-1"></span
            ></a>
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Contact us
            </div>
            <a class="my-3 block" href="/#"
              >XXX XXXX, Floor 4 San Francisco, CA
              <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >contact@company.com <span class="text-white text-xs p-1"></span
            ></a>
          </div> -->
        </div>
      </div>
      <!-- End of Footer code -->

      <div class="pt-2 text-left">
        <div
          class="flex pb-5 px-3 m-auto pt-5 border-t border-orange-300 text-gray-800 text-sm flex-col md:flex-row max-w-6xl"
        >
          <div class="mt-2">
            © Copyright {{ new Date().getFullYear() }} Restimuli. All Rights
            Reserved.
          </div>
          <div class="md:flex-auto md:flex-row-reverse mt-2 flex-row flex">
            <a href="https://twitter.com/restimuli" target="_blank" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 1000 1000"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Twitter"
                  d="M500 990c270.6 0 490-219.4 490-490S770.6 10 500 10 10 229.4 10 500s219.4 490 490 490zM356 374.5c94.2 47.6 173.8 44.8 173.8 44.8s-30.2-105.2 63.1-151.8c93.3-46.6 157.5 32 157.5 32s16.3-4.5 28.4-8.9c12.1-4.5 29.7-12.4 29.7-12.4l-28.7 51.3 44.3-4.7s-5.5 8-23.2 24.2-25 24.6-25 24.6 6.3 126.6-60.4 224.1-152.9 156-278.1 168.3-206.7-38.4-206.7-38.4 54.7-3.1 89.6-16.5c34.9-13.3 85.1-48.5 85.1-48.5s-71.3-22-97-46.6c-25.6-24.7-32-39.3-32-39.3l70.4-.9s-74.1-39.3-95.1-70.4c-21-31.1-23.8-61.3-23.8-61.3L282 466s-45-61.2-51.4-108.8c-6.4-47.6 8.2-73.2 8.2-73.2s23 42.9 117.2 90.5z"
                ></path>
              </svg>
            </a>
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Facebook"
                  d="M23.998 12c0-6.628-5.372-12-11.999-12C5.372 0 0 5.372 0 12c0 5.988 4.388 10.952 10.124 11.852v-8.384H7.078v-3.469h3.046V9.356c0-3.008 1.792-4.669 4.532-4.669c1.313 0 2.686.234 2.686.234v2.953H15.83c-1.49 0-1.955.925-1.955 1.874V12h3.328l-.532 3.469h-2.796v8.384c5.736-.9 10.124-5.864 10.124-11.853z"
                ></path>
              </svg>
            </a> -->
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-gray-500 hover:text-gray-400"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <g id="Layer_1">
                  <circle id="Oval" cx="12" cy="12" r="12"></circle>
                  <path
                    id="Shape"
                    d="M19.05,8.362c0,-0.062 0,-0.125 -0.063,-0.187l0,-0.063c-0.187,-0.562
                     -0.687,-0.937 -1.312,-0.937l0.125,0c0,0 -2.438,-0.375 -5.75,-0.375c-3.25,0
                     -5.75,0.375 -5.75,0.375l0.125,0c-0.625,0 -1.125,0.375
                     -1.313,0.937l0,0.063c0,0.062 0,0.125 -0.062,0.187c-0.063,0.625 -0.25,1.938
                     -0.25,3.438c0,1.5 0.187,2.812 0.25,3.437c0,0.063 0,0.125
                     0.062,0.188l0,0.062c0.188,0.563 0.688,0.938 1.313,0.938l-0.125,0c0,0
                     2.437,0.375 5.75,0.375c3.25,0 5.75,-0.375 5.75,-0.375l-0.125,0c0.625,0
                     1.125,-0.375 1.312,-0.938l0,-0.062c0,-0.063 0,-0.125
                     0.063,-0.188c0.062,-0.625 0.25,-1.937 0.25,-3.437c0,-1.5 -0.125,-2.813
                     -0.25,-3.438Zm-4.634,3.927l-3.201,2.315c-0.068,0.068 -0.137,0.068
                     -0.205,0.068c-0.068,0 -0.136,0 -0.204,-0.068c-0.136,-0.068 -0.204,-0.204
                     -0.204,-0.34l0,-4.631c0,-0.136 0.068,-0.273 0.204,-0.341c0.136,-0.068
                     0.272,-0.068 0.409,0l3.201,2.316c0.068,0.068 0.136,0.204
                     0.136,0.34c0.068,0.136 0,0.273 -0.136,0.341Z"
                    style="fill: rgb(255, 255, 255);"
                  ></path>
                </g>
              </svg>
            </a> -->
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Linkedin"
                  d="M7.3,0.9c1.5,-0.6 3.1,-0.9 4.7,-0.9c1.6,0 3.2,0.3 4.7,0.9c1.5,0.6 2.8,1.5
                  3.8,2.6c1,1.1 1.9,2.3 2.6,3.8c0.7,1.5 0.9,3 0.9,4.7c0,1.7 -0.3,3.2
                  -0.9,4.7c-0.6,1.5 -1.5,2.8 -2.6,3.8c-1.1,1 -2.3,1.9 -3.8,2.6c-1.5,0.7
                  -3.1,0.9 -4.7,0.9c-1.6,0 -3.2,-0.3 -4.7,-0.9c-1.5,-0.6 -2.8,-1.5
                  -3.8,-2.6c-1,-1.1 -1.9,-2.3 -2.6,-3.8c-0.7,-1.5 -0.9,-3.1 -0.9,-4.7c0,-1.6
                  0.3,-3.2 0.9,-4.7c0.6,-1.5 1.5,-2.8 2.6,-3.8c1.1,-1 2.3,-1.9
                  3.8,-2.6Zm-0.3,7.1c0.6,0 1.1,-0.2 1.5,-0.5c0.4,-0.3 0.5,-0.8 0.5,-1.3c0,-0.5
                  -0.2,-0.9 -0.6,-1.2c-0.4,-0.3 -0.8,-0.5 -1.4,-0.5c-0.6,0 -1.1,0.2
                  -1.4,0.5c-0.3,0.3 -0.6,0.7 -0.6,1.2c0,0.5 0.2,0.9 0.5,1.3c0.3,0.4 0.9,0.5
                  1.5,0.5Zm1.5,10l0,-8.5l-3,0l0,8.5l3,0Zm11,0l0,-4.5c0,-1.4 -0.3,-2.5
                  -0.9,-3.3c-0.6,-0.8 -1.5,-1.2 -2.6,-1.2c-0.6,0 -1.1,0.2 -1.5,0.5c-0.4,0.3
                  -0.8,0.8 -0.9,1.3l-0.1,-1.3l-3,0l0.1,2l0,6.5l3,0l0,-4.5c0,-0.6 0.1,-1.1
                  0.4,-1.5c0.3,-0.4 0.6,-0.5 1.1,-0.5c0.5,0 0.9,0.2 1.1,0.5c0.2,0.3 0.4,0.8
                  0.4,1.5l0,4.5l2.9,0Z"
                ></path>
              </svg>
            </a> -->
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Combined-Shape"
                  d="M12,24c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12c-6.627,0
                  -12,5.373 -12,12c0,6.627 5.373,12 12,12Zm6.591,-15.556l-0.722,0c-0.189,0
                  -0.681,0.208 -0.681,0.385l0,6.422c0,0.178 0.492,0.323
                  0.681,0.323l0.722,0l0,1.426l-4.675,0l0,-1.426l0.935,0l0,-6.655l-0.163,0l-2.251,8.081l-1.742,0l-2.222,-8.081l-0.168,0l0,6.655l0.935,0l0,1.426l-3.74,0l0,-1.426l0.519,0c0.203,0
                  0.416,-0.145 0.416,-0.323l0,-6.422c0,-0.177 -0.213,-0.385
                  -0.416,-0.385l-0.519,0l0,-1.426l4.847,0l1.583,5.704l0.042,0l1.598,-5.704l5.021,0l0,1.426Z"
                ></path>
              </svg>
            </a> -->
          </div>
        </div>
      </div>

      
    </section>

    <!-- <div class="fixed bottom-0 right-0">
      <a
        class="flex items-center gradient px-3 py-2 rounded-tl-lg text-white border-t border-l"
        href="https://twitter.com/celue"
      >
        <img class="w-6 rounded-full mr-2" src="/pat.jpg" /> Created by Pat
        Eskinasy
      </a>
    </div> -->


    <div class="fixed bottom-0 right-0 flex items-center gradient px-3 py-2 rounded-tl-lg border-t border-l">
      <span class="text-white font-semibold text-white "> Say hi</span> 
        
      <a class="mx-3 flex flex-row bg-white pr-1 py-0.5 rounded-md text-sm font-semibold" href="https://twitter.com/celue" target="_blank"><img class="w-6 rounded-full mx-1" src="/pat.jpg" />
      <span class="mt-0.5">@celue</span>
      </a>
      
      <a class="mr-2 bg-white px-1 py-1 rounded-md text-sm font-semibold" href="https://twitter.com/restimuli" target="_blank"><span class="align-middle">@restimuli</span></a>
    </div>


  </div>
    <VideoBubble :style="{ marginBottom: '20px' }" closeButtonOffset="20"/>
</template>

<script>
import { format } from "timeago.js";
import VideoBubble from '@/components/VideoBubble.vue';

const BUILD_DATE = process.env.VUE_APP_BUILD_DATE;
const COMMIT_HASH = process.env.VUE_APP_COMMIT_HASH;

export default {
  name: "App",

  props: {
    containerClass: {
      type: String,
      default: 'relative',
    },
  },

  data() {
    return {
      error: null,
      loading: true,
      buildDate: BUILD_DATE ? format(BUILD_DATE) : null,
      commitHash: COMMIT_HASH,
      show: ["donating", "", "ads"],
      category: null,
      icon: "\uf0e0",

      // code for FAQ
      faqs: [
        [
          {
            question: 'You doubt buyers really care about sustainability.',
            answer: {
              text: 'According to a recent McKinsey’s study¹, over 20% of large buyers already use sustainability measures as primary criteria in sourcing decisions or supplier reviews, whereas over 60% are working on their sustainability strategy for procurement. Suppliers that aren’t showing progress risk losing relevance. Read Restimuli\'s suppliers memo for more',
              link: {
                text: 'Read Restimuli\'s suppliers memo',
                url: 'https://publication.restimuli.com/memo/'
              }
            }
          },
          {
            question: 'You’re worried it will take too much time.',
            answer: {
              text: 'It takes an average of just 15 minutes to choose the value tags that best describe your company values. From there, we’ll do a call, documenting how aligned those values are with your operations. It is an interview, you don’t need to prepare anything at all. We then develop your Restimuli profile. You are in control of the narrative, and only when you approve the draft, we publish your profile.',
              link: {
                text: 'choose the value tags',
                url: 'https://docs.google.com/spreadsheets/d/1ZoKYUSz9Gf-bVFPZAW0FLUekecYJrfhlFI1BBbHiPTA/edit?usp=sharing'
              }
            }
            },
            {
            question: 'Your eco credentials aren’t strong enough.',
            answer: {
              text: 'Restimuli works for brands at all stages of their ESG journey – many of the suppliers we work with, showcase 3 or fewer value tags. Don’t wait for perfection – start getting rewarded for your progress now.',
              link: null
            }
          }
            
            ],
            [
            // {
            // question:
            // 'Am I eligible for a Restimuli profile?',
            // answer:
            // 'Yes, as long as the following criteria are met:\n• You offer essential industries resources (Pharma, PPE, Medical Devices, Diagnostics, Chemicals, Polymers, Logistics, Sanitisers, etc.).\n• You maintain a level of sustainability and ethical standards.',
            // },
            // {
            // question: 'It doesn’t look like value for money as a small company.',
            // answer:
            // 'We work with several small, growing companies, so we’ve made sure to keep costs as low as possible. Discounts are available for companies with low annual turnovers – speak with our team to find out more.',
            // },
            {
            question:
            'You already have certifications.',
            answer: {
            text: 'Your buyers and investors are busy, which means your certifications are going unnoticed in product description copy and ESG reporting. By adding those certifications to your Restimuli profile and allowing buyers/investors to discover your offering using value tag filters, Restimuli makes your certifications work much harder, generating new buyer/investor interest.',
            link: null
            }
            },
            {
            question:
              'How can a Restimuli profile help your sales and investor relations team.',
            answer: {
              text:'ESG has become a license to operate in many industries. Beyond the numerous advantages of having a Restimuli profile, your profile can be included in outbound emails to potential buyers / investors, streamlining communication. There is a sense of enthusiasm according to feedback from other suppliers as it makes such emails much shorter and lets potential clients opt in to all this information on narrative-based ethical positioning – substantiated by your business practices –. This ultimately aids in boosting email response rates.',
              link: null
            }
            }
            ],
            [
            {
            question: 'You doubt investors really care about your ethical and sustainability standards.',
            answer: {
              text: 'Investing within an ESG framework is now the fastest growing segment of the asset management industry. That said, ESG can sadly be used as a very loosely defined term for “greenwashing”. A Restimuli profile helps you articulate your ESG values and how well these are translated into daily practices and operations. Transparency is key to mitigate market confusion.',
              link: null
            }
            ,
            },
            // {
            // question: 'I’d rather wait until Restimuli goes live.',
            // answer: 'The 25 early customers supporting Restimuli’s launch join our inner circle programme (discounts and more included) – speak with our team to find out more.',
            // },
            {
            question: 'Your product donation programs are a key element of your ESG efforts, particularly in the area of social responsibility. You are curious about how they fit in.',
            answer: {
              text: 'We build your profile and storefront. Restimuli builds your catalogue and organizes all your ESG/CSR and product content. Buyers and investors can learn everything about your ethical, environmental, social, governance, and philanthropic values and culture from your profile and about your product credentials from your storefront. Your storefront is designed to also showcase product donations should you have programmes in place.',
              link: null
            }
            },
            ],
            ],
    // end of code for FAQ

    };
  
  },

  // computed: {
  //   
  // },

  methods: {
    cleanKey(key) {
      return key
        .toLowerCase()
        .replace(/[^a-z]+/gi, "_")
        .replace(/(^_|_$)/g, "");
    },
    cleanValue(key, value) {
      if (key === "category" && value.startsWith("Other")) return "Other";
      return value;
    },
    toggle(type) {
      const add = !this.show.includes(type);
      if (add) this.show.push(type);
      else this.show.splice(this.show.indexOf(type), 1);
    },
    generateAnswer(faq) {
      if (!faq.answer.link) {
        return faq.answer.text;
      } else {
        const link = `<a href='${faq.answer.link.url}' class='text-yellow-900 font-bold' target='_blank' rel='noopener noreferrer' style='color: rgb(66 32 6) !important';>${faq.answer.link.text}</a>`;
        const answer = faq.answer.text.replace(faq.answer.link.text, link);
        return answer.replace(/\n/g, '<br>');
      }
    },
  },

  mounted() {
    //Javascript to toggle the menu
    document.getElementById("nav-toggle").onclick = function() {
      document.getElementById("nav-content").classList.toggle("hidden");
    };
  },
  components: {
    VideoBubble,
  },

}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}

#tags-container {
  justify-content: space-between;
}

@media (max-width: 1000px) {
  #tags-container {
    flex-wrap: wrap;
  }
}

#tag-list {
  /* width: 100%; */
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 25px;
}

@media (max-width: 1000px) {
  #tag-list {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  #tag-list {
    flex-direction: row;
  }
}

@media (max-width: 1000px) {
  #tag-column {
    flex-direction: column;
    min-width: 49.68%;
  }
}

@media (max-width: 600px) {
  #tag-column {
    display: inline-block;
    min-width: 250px;
    width: auto;
  }
}

#tag-list-header {
  border-bottom: 2px solid #e6e6e6;
  width: fit-content;
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
#close-button {
  margin-bottom: 20px !important;
}
</style>
